import request from './request'
/**
 * @author 孟祥龙
 * @Desc TODO 诗词相关请求
 * @date 2021/5/6 16:52
 * @return
 */
// 获取名句
export const GetSentences = (params) => request.get("/home/getSentenceRandom",{params});

// 获取诗词(高权重)
export const GetHighWeightPoems = (params) => request.get("/home/getHighWeightPoems",{params});

// 按照id获取诗词
export const GetPoemById = (params) => request.get("/poem/getPoemById",{params});

// 按照id获取所有标签
export const GetTagsByPoemId = (params) => request.get("/poem/geTagByPoemId",{params});

// 根据TagId获取诗词
export const GetPoemsByTagId = (params) => request.get("/poem/getPoemByTagId",{params});

// 根据PoetId获取诗词信息
export const GetPoemByPoetId = (params) => request.get("/poem/getPoemByPoetId",{params});

// 根据tagId获取诗词
export const GetPoemByTagId = (params) => request.get("/poem/getPoemByTagId",{params});
